import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import moment from 'moment'
import Chartist from 'chartist'
import chartistLegend from 'chartist-plugin-legend'
import {SCREEN_SM_MIN} from '../../core/browser'
import DashboardPanel from '../../core/components/DashboardPanel'
import Chart from '../../core/components/Chart'
import i18n from '../i18n'
import style from './ScoreDashboardPanel.less'

function reportFilter(audit) {
    return (report) => {
        return report.parentAudit.uid == audit.uid
    }
}

function auditAggregator(result, report) {
    var audit = result.find((a) => a.uid == report.parentAudit.uid)

    if (!audit) {
        result.push(report.parentAudit)
    }
    return result
}

function aggregate(reports) {
    const audits = reports.reduce(auditAggregator, [])
    const aggregations = audits.map((audit) => {
        const auditReports = reports.filter(reportFilter(audit))

        return {
            audit: audit,
            reports: auditReports
        }
    })

    return aggregations
}

class ScoreDashboardPanel extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {
            aggregations: []
        }
    }

    componentWillMount() {
        const {stream} = this.props

        const aggregations = aggregate(stream)
        this.setState({aggregations})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.stream != this.props.stream) {
            const {stream} = nextProps
            
            const aggregations = aggregate(stream)
            this.setState({aggregations})
        }
    }

    render() {
        const {dispatch, stream, ...others} = this.props
        const {aggregations} = this.state

        const panelHeader = (
            <h4>{i18n.auditScores}</h4>
        )

        const chartAxisX = () => {
            var axisX = {
                divisor: 4,
                offset: 20,
                labelInterpolationFnc: (v) => moment(v).format(i18n.dateFormat.short)
            }

            if (stream.length > 1) {
                axisX = {
                    type: Chartist.FixedScaleAxis,
                    ...axisX
                }
            }

            return axisX
        }

        const chartAxisY = {
            type: Chartist.FixedScaleAxis,
            high: 1,
            low: 0,
            ticks: [0, 0.2, 0.4, 0.6, 0.8, 1],
            labelInterpolationFnc: (v) => (v * 100) + '%'
        }

        const chartPadding = {
            left: 0,
            right: 5,
            bottom: 0
        }

        const chartPlugins = [
            chartistLegend({
                legendNames: aggregations.map((a) => a.audit.name)
            })
        ]

        const chartResponsive = [
            ['screen and (min-width: ' + SCREEN_SM_MIN + 'px)', {
                axisX: {
                    divisor: 7
                }
            }]
        ]

        return (
            <DashboardPanel
                header={panelHeader}
                {...others}>
                {aggregations.length > 0 && (
                    <Chart fill showArea
                        kind='Line'
                        chartPadding={chartPadding}
                        axisX={chartAxisX()}
                        axisY={chartAxisY}
                        lineSmooth={Chartist.Interpolation.simple()}
                        plugins={chartPlugins}
                        responsive={chartResponsive}
                        serie={(a) => a.reports}
                        display={(r) => new Date(r.created)}
                        identify={(r) => r.score}
                        value={aggregations} />
                )}
            </DashboardPanel>
        )
    }
}

ScoreDashboardPanel = connect((state) => ({
    stream: state.audit.report.stream
}))(ScoreDashboardPanel)

export default ScoreDashboardPanel


// WEBPACK FOOTER //
// ./lib/audit/components/ScoreDashboardPanel.js